<script>
  import {classNames} from "../../utils.js";
  import IconInfo from "lucide-svelte/icons/info";

  let {
        class: classInput,
        // variant = "default",
        // size    = "default", 
        ref = $bindable(null),
        children,
        ...restProps
      } = $props();

  let bIsTest = true;
</script>

<span class="info">
<IconInfo bind:this={ref} style="width: 13px; height: 13px;" class={classNames('hmk-calendar-info', {extra: bIsTest}, classInput)} {...restProps}/>
  {@render children?.()}
</span>

<style>
  .info {
    /*color: var(--hmk-clr-theme-primary);*/
    color: #1c1c1c;
  }
</style>

